import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';

@Component({
  selector: 'app-mobile-gallery',
  templateUrl: './mobile-gallery.component.html',
  styleUrls: ['./mobile-gallery.component.css']
})
export class MobileGalleryComponent extends BaseListCtl{
  datePickerConfig : Partial<BsDatepickerConfig>;

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute) {
    super(locator.endpoints.MOBILEGALLERY,locator,route);

    this.datePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: true,
        
        maxDate: new Date(),
        dateInputFormat: 'YYYY/MM/DD'
      });

  }
  sid = localStorage.getItem('sessionId');
  
  populateForm(form, data) {
    form.id = data.id;
    form.dateTime=data.dateTime;
    form.dateTime1=data.dateTime1;
    form.date=data.date;
    form.endTime=data.endTime;
    form.userId=data.userId;
    form.userName=data.userName;
    form.fileName=data.fileName;
    form.type=data.type;
    form.mobileId=data.mobileId;
    form.tags=data.tags;
    form.size=data.size;
    form.description=data.description;
    form.skey = data.skey;
    console.log('----->',data);
  }

  
}
